import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosAuth } from "../config/axiosInstance";
import { PERSONALISED_VIDEO_PLAYER_BACKEND_BASE_URL } from "../config/api_config";
import { resolveCourseId } from "../utilities/videoPlayerApi";

export const dispatchScholarshipData = createAsyncThunk(
    'scholarship/dispatchScholarshipData',
    async ({ course_id } = {}, { getState }) => {
        const courseId = resolveCourseId(getState(), course_id);
        const response = await axiosAuth.patch(
            `${PERSONALISED_VIDEO_PLAYER_BACKEND_BASE_URL}/api/v1/courses/${courseId}`,
            { operation: 'apply_scholarship' }
        );
        return response.data;
    }
);

const initialState = {
    minutes: 0,
    seconds: 0,
    timeExpired: false,
    appliedAt: 0,
    result: null,
};

const scholarshipSlice = createSlice({
    name: 'scholarshipDetails',
    initialState,
    reducers: {
        setTimer: (state, action) => {
            const { minutes, seconds } = action.payload;
            state.minutes = minutes;
            state.seconds = seconds;
        },
        setTimeExpired: (state, action) => {
            state.timeExpired = action.payload;
        },
        setCreatedAt: (state, action) => {
            state.appliedAt = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(dispatchScholarshipData.fulfilled, (state, action) => {
            state.result = action.payload;
        });
    },
});

export const selectScholarshipData = (state) => state.scholarshipDetails;
export const { setTimeExpired, setTimer, setCreatedAt } = scholarshipSlice.actions;
export default scholarshipSlice.reducer;
